import React, { lazy, Suspense } from "react";
import { Provider } from 'react-redux';
import { store } from '../redux/store';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import {ROLES_PAGES} from "../redux/context/allowedTypes";
import { AuthProvider } from "../redux/context/authProvider";
import ResponsiveAppBar from '../components/Dashboard/navBar/appBar';
import ResponsiveBodyContainer from '../components/Dashboard/responsiveBody/responsiveBodyContainer';
import VoiceCall from '../components/vocieCall/voice.js';
import './App.css';
import { RTSPProvider } from "../redux/context/RTSPProvider";
import RoadsRecorderHistory from "../pages/RoadsRecorderHistory/RoadsRecorderHistory";
import Statistics_new from "../pages/siteManager/statistics_new/Statistics_new";

const SiteManagement = lazy(() => import('../pages/siteManagement/siteManagement'));
const CartInfo = lazy(() => import('../pages/CartInfo/newCartInfo'));
const EventHistory = lazy(() => import('../pages/eventHistory/eventHistory'));
const CartManagement = lazy(() => import('../pages/cartManagement/cartManagement'));
const Login = lazy(() => import('../pages/login/login'));
const ProtectedRoutes = lazy(() => import('../hooks/Auth/RequiredAuth'));
const SiteOverView = lazy(() => import('../pages/siteManager/siteOverview'));
const SiteConfigurationPage = lazy(() => import("../pages/siteConfiguration/siteConfiguration"));

const Statistics = lazy(() => import('../pages/siteManager/statistics'));
const NotAllowed = lazy(() => import('../pages/InvalidUser/notAllowed'));
const Permissions = lazy(() => import('../pages/permissions/permissions'));
const FeedbackManagement = lazy(()=> import("../pages/feedbackManagement/feedbackManagement")) ;
const MissionsPage = lazy(()=> import("../pages/MissionsManagement/MissionsManagement")) ;


function App() {
  return (
    <Router>
      <AuthProvider>
        <RTSPProvider>
          <Provider store={store}>
            {/* this voice call component creates 2 connections to server.. */}
            <VoiceCall />
            <ResponsiveAppBar />
            <ResponsiveBodyContainer>
              <Suspense fallback={<div></div>}>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/" element={<Navigate to="/login" replace />} />
                  
                  <Route path="/dashboard_statistics" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard}>
                      {/* <Statistics /> */}
                      <Statistics_new />
                      
                    </ProtectedRoutes>} />
                    
                  <Route path="/dashboard_site" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard}>
                      <SiteOverView />
                    </ProtectedRoutes>} />
                    
                  <Route path="/dashboard_events" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard_events}>
                      <EventHistory />
                    </ProtectedRoutes>} />
                    
                  <Route path="/not_allowed" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.not_allowed}>
                      <NotAllowed />
                    </ProtectedRoutes>} />
                    
                  <Route path="/permissions" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.permissions}>
                      <Permissions />
                    </ProtectedRoutes>} />
                    
                  <Route path="/cart/info/:cartId" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.cart_info}>
                      <CartInfo />
                    </ProtectedRoutes>} />
                    
                  <Route path="/dashboard_siteManagement" 
                    element={
                    <ProtectedRoutes allowed={ROLES_PAGES.dashboard_siteManagement}>
                      <SiteManagement />
                    </ProtectedRoutes>
                  } />

                  <Route path="/dashboard_roads" 
                    element={
                    <ProtectedRoutes allowed={ROLES_PAGES.dashboard_roads}>
                      <RoadsRecorderHistory />
                    </ProtectedRoutes>
                  } />
                    
                  <Route path="/dashboard_cartConfiguration" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard_cartConfiguration}>
                      <CartManagement />
                    </ProtectedRoutes>} />
                    
                  <Route path="/dashboard_feedbacks" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard_cartConfiguration}>
                      <FeedbackManagement />
                    </ProtectedRoutes>} />
                    
                  <Route path="/dashboard_missions" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.dashboard_missions}>
                      <MissionsPage />
                    </ProtectedRoutes>} />
                    
                  <Route path="/site_settings" 
                    element={<ProtectedRoutes allowed={ROLES_PAGES.site_settings}>
                      <SiteConfigurationPage />
                    </ProtectedRoutes>} />
                </Routes>
              </Suspense>
            </ResponsiveBodyContainer>
          </Provider>
        </RTSPProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
